/**
 * The (name of the) command which transports the state (represented by
 * {State} for the local state at the time of this writing) of a {FollowMe}
 * (instance) between participants.
 */
export const FOLLOW_ME_COMMAND = 'follow-me';
